import { SUBSCRIBE, UNSUBSCRIBE } from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const subscribe = namespace => socket.request(SUBSCRIBE, namespace)
export const unsubscribe = namespace => socket.request(UNSUBSCRIBE, namespace)
